import { gql } from '@apollo/client';

export const fetchEntitlementIdsForEndCustomerContact = gql`
  query fetchEntitlementIdsForEndCustomerContact($searchParams: EndCustomerContactSearchParams) {
    endCustomerContacts(searchParams: $searchParams) {
      totalCount
      nodes {
        picture
        name
        accountId
        email
        entitlements {
          entitlementIds
        }
      }
    }
  }
`;
